module.exports = __webpack_public_path__ + "static/media/logoutdark.1e3920d6.svg";